import { memo } from "react";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const UploadDocumentsLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].UploadDocuments}`}
        Icon={DocumentScannerIcon}
        {...props}
    >
        Upload Documents
    </StepLabel>
);

export default memo(UploadDocumentsLabel);
